export const API_BASE_URL = 'https://backend.darshangr.workers.dev/api';

export const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};
